import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from '../SchoolShow_style'
import Button from 'components/Button/Button'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'

const FacultyCtaCard = (props) => {
    const { school } = props
    const classes = useStyles()

    return (
        <Box className={classes.facultyCtaBox}>
            <Typography variant='h1' component='h2' className={classes.ctaFacultyTitle}>
                {school.cta_faculties_title}
            </Typography>
            <Typography
                component='span'
                className={classes.ctaFacultyDescription}
                dangerouslySetInnerHTML={{ __html: school.cta_faculties_description }}
            />
            <RouteMapLink target='_blank' redirectionUrl={school.cta_faculties_url}>
                <Button size='small' className={classes.moreInfoButton}>
                    {school.cta_faculties_url_title}
                </Button>
            </RouteMapLink>
        </Box>
    )
}

export default FacultyCtaCard
